// context/AdminLayoutContext.tsx
import { createContext, useContext } from "react";

type AdminLayoutContextType = {
  setActiveMenu: React.Dispatch<React.SetStateAction<string>>;
  setActiveSubItem: React.Dispatch<React.SetStateAction<string>>;
};

export const AdminLayoutContext = createContext<
  AdminLayoutContextType | undefined
>(undefined);

export function useAdminLayoutContext() {
  const context = useContext(AdminLayoutContext);
  if (!context) {
    throw new Error(
      "useAdminLayoutContext debe usarse dentro de AdminLayoutContext.Provider"
    );
  }
  return context;
}
